import { BackendSearch } from '@shared/datastore/core';
import { SearchFreelancersResultAjax } from './search-freelancers.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchFreelancers: SearchFreelancersResultAjax;
  }
}

export const searchFreelancersBackend: BackendSearch = {
  fetch: q => ({
    endpoint: `search/topFreelancer.php`,
    isGaf: true,
    params: q,
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-freelancers/search-freelancers.backend.ts